import React from "react";
import { GraduationCap, Globe, ShieldCheck } from "lucide-react";
import hecLogin from "../assets/img/loginhec.png";
import { FooterComponents } from "./FooterComponent";

/** Left-hand brand panel of the sign-in screen (desktop only). */
export default function LogoComponent() {
  const points = [
    { icon: GraduationCap, text: "Local bursaries and student loans" },
    { icon: Globe, text: "International scholarship opportunities" },
    { icon: ShieldCheck, text: "Secure, role-based access for HEC and institutions" },
  ];

  return (
    <div className="hidden lg:flex flex-col justify-between h-screen w-full lg:w-[35vw] 2xl:w-[30vw] relative overflow-hidden bg-gradient-to-b from-cyan-900 via-cyan-800 to-cyan-700 text-white">
      {/* decorative rings */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-72 h-72 rounded-full bg-white/5" />
      <div className="pointer-events-none absolute -bottom-32 -left-20 w-96 h-96 rounded-full bg-white/5" />

      <div className="relative flex-1 flex flex-col items-center px-10 pt-16">
        <div className="bg-white rounded-2xl p-4 shadow-xl">
          <img src={hecLogin} alt="Higher Education Council" className="w-28 lg:w-32 2xl:w-36" />
        </div>
        <h1 className="mt-8 text-2xl 2xl:text-3xl font-bold tracking-tight text-center">HEC MIS</h1>
        <p className="mt-2 text-sm text-cyan-100 text-center max-w-xs">
          Scholarship Management Information System of the Higher Education Council, Rwanda.
        </p>

        <ul className="mt-10 space-y-4 w-full max-w-xs">
          {points.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-start gap-3 text-sm text-cyan-50">
              <span className="mt-0.5 inline-flex w-8 h-8 items-center justify-center rounded-lg bg-white/10 border border-white/15 flex-shrink-0">
                <Icon className="w-4 h-4" />
              </span>
              <span className="leading-6">{text}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="relative w-full p-8">
        <FooterComponents login={"true"} />
      </div>
    </div>
  );
}
